<template>
  <div class="pe_formmodal">
    <div class="pe_formmodal_close-button"><span @click="$emit('close')">X</span></div>
    <div class="pe_form-container">
      <p><strong>Have something to share? Experiencing an issue?</strong></p>
      <p><strong>We value your feedback!</strong></p>
      <p>Complete the contact form below to send us a message.</p>
      <p>Please note, we are unable to answer bug reports individually.</p>
      <label for="name">Name *
        <span v-if="formErrors && formErrors.name" class="error">
          {{ formErrors.name }}
        </span>

      </label>

      <input type="text" v-model="name" :class="{ 'error': formErrors && formErrors.name }" @keyup="validateFormOnKey()"
        autocomplete="name">


      <label for="email">Email *
        <span v-if="formErrors && formErrors.email" class="error">
          {{ formErrors.email }}
        </span>

      </label>
      <input type="email" v-model="email" :class="{ 'error': formErrors && formErrors.email }"
        @keyup="validateFormOnKey()" autocomplete="email">


      <label for="category">Feedback type *
        <span v-if="formErrors && formErrors.category" class="error">
          {{ formErrors.category }}
        </span>

      </label>
      <select required v-model="category">
        <option value="">Select an option...</option>
        <option value="bug">Report a bug</option>
        <option value="comment">General comment</option>
        <option value="compliment">Compliment</option>
      </select>

      <label for="message">Message *
        <span v-if="formErrors && formErrors.message" class="error">
          {{ formErrors.message }}
        </span>

      </label>
      <textarea cols="30" rows="4" v-model="message" :class="{ 'error': formErrors && formErrors.message }"
        @keyup="validateFormOnKey()" autocomplete="off">
            </textarea>


      <button v-if="!this.success && !this.apiLoading" class="pe_form_submit_button" type="submit"
        @click.prevent="submitForm()">Submit</button>
      <p v-if="this.apiLoading"><br>Sending feedback... Please wait</p>
      <p v-if="this.isSent"><br>Thank you, your feedback has been submitted</p>
      <br>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import debounce from 'throttle-debounce'

import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'

import api from '@puzzleapps/shared/src/utils/api'

export default {
  name: 'support-modal',
  props: ['date'], // date, format YYYY-MM-DD

  components: {
    Spinner,
  },

  data() {
    return {
      formErrors: null,
      name: '',
      email: '',
      message: '',
      category: '',
      EMAIL_REGEXP: /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
      lastError: null,
      apiResponse: null,
      apiLoading: null,
      success: false,
      isSent: false,
    }
  },

  mounted() {
    this.lastError = JSON.stringify(this.stateError)
    this.clearError()
  },


  methods: {
    ...mapActions({
      clearError: 'errors/clearError'
    }),
    validateFormOnKey() {
      if (!this.errors) return

      this.validateForm()
    },

    validateForm() {
      let totalErrors = 0

      this.formErrors = {
        name: '',
        email: '',
        message: '',
        category: '',
      }

      for (let key in this.formErrors) {
        if (this[key] == '') {
          this.formErrors[key] = 'Field is required'
          totalErrors++
        }
      }

      if (
        this.email != "" &&
        (this.email.length <= 5 || !this.EMAIL_REGEXP.test(this.email))
      ) {
        this.formErrors.email = 'Incorrect email format'
        totalErrors++
      }


      return (totalErrors === 0)
    },

    submitForm() {
      let isValid = this.validateForm()

      if (!isValid) {
        return
      }

      let body = {
        clientAppId: this.clientAppId,
        clientScheduleId: this.game.puzzleId,
        playId: this.game.playId,
        name: this.name,
        email: this.email,
        feedbackType: this.category,
        message: this.message,
        userAgent: navigator.userAgent,
        resolution: `${window.screen.width} X ${window.screen.height}`,
      }

      if (process.env.NODE_ENV === 'development') {
        console.log(body)
      }

      this.apiLoading = true

      api.postSupportTicket(body)
        .then(res => {
          this.success = true
          this.apiResponse = res.message
          this.isSent = true
        })
        .catch(err => {
          this.apiResponse = 'Error creating ticket: ' + err.message
          this.isSent = true
        })
        .finally(() => this.apiLoading = false)
    }
  },
  computed: {
    ...mapState({
      game: state => state.game,
      clientAppId: state => state.clientAppId || window.PE_CLIENTAPP_ID,
      stateError: state => state.errors.error,
    }),
  }
}

</script>

<style scoped lang="scss">
#puzzleapp {
  .pe_formmodal_close-button {
    align-self: flex-end;
    padding: 10px;
    cursor: pointer;
    text-align: right;
    font-size: 1.5em;
  }

  .pe_formmodal {

    position: absolute;
    width: 100%;
    max-width: 100%;
    //top: 1%;
    //left: 1%;
    right: 0;
    top: 0;
    height: 100%;
    background: var(--modal-background);
    color: #fff;
    z-index: 30;
    overflow: auto;

  }

  .pe_form-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 500px;
    margin: 0 auto;
    padding: 0 8px;


  }

  select {
    font-family: Poppins, Helvetica, Arial, sans-serif !important;
  }

  .pe_form-container label {
    //font-weight: bold;
    color: #fff;
    text-align: left;
    padding: 0 5px;
    font-size: 0.8em;
    margin-top: 15px;
  }

  .pe_form-container input[type="text"],
  .pe_form-container input[type="email"],
  .pe_form-container textarea,
  .pe_form-container select {
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 5px;
    width: 100%;

    &.error {
      background: #f38c8c;

    }

    option {


      .error {
        background-color: #f38c8c;
      }

    }
  }

  .pe_form-container p {
    color: #fff;
    font-weight: 400;
    font-size: 0.8em;
  }

  .pe_form-container button {
    border-radius: 5px;
    padding: 10px;
    background: var(--crossword-menu-btn-background);
    color: var(--crossword-menu-btn-color);
    cursor: pointer;

    &:hover {
      background: var(--crossword-menu-btn-hover);
      color: #000;
    }
  }

  .pe_form-container span {
    &.error {
      color: #f87272;

    }

  }

  .pe_form_submit_button {
    // border-radius: 5px;
    // padding: 10px;
    // background: var(--crossword-menu-btn-background);
    // color: var(--crossword-menu-btn-color);
    // cursor: pointer;
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-weight: 600;
  }
}
</style>